// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1I1e5","col":"Table_col__A28_S","fulfillmentStatus":"Table_fulfillmentStatus__1rXkm","emailCol":"Table_emailCol__4wbUM"};